export default __webpack_public_path__ + "9515aca1e49b9b5f72c01a203e95e67a.svg";